import { Dialog, DialogProps } from 'components'
import { ManageMedia, ManageMediaProps } from '.'

export interface Props extends ManageMediaProps {
  open: boolean
  onClose: () => void
  dialogProps?: Omit<DialogProps, 'children' | 'open' | 'onClose'>
}

export default function ManageMediaDialog({ open, onClose, dialogProps, ...rest }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      size="xl"
      placement="center"
      scrollBehavior="inside"
      contentProps={{ maxWidth: '90vw', height: '80vh' }}
      bodyProps={{ display: 'flex' }}
      title="Manage Media"
      {...dialogProps}
    >
      <ManageMedia {...rest} />
    </Dialog>
  )
}
